import {IconButton, Stack, TableCell, TableRow, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Delete02Icon, PencilEdit01Icon} from "@hugeicons/core-free-icons";
import moment from "moment";
import {CampaignStatusChipsNew} from "./CampaignStatusChipsNew";
import {extensionLabel} from "../../../project/campaigns/hooks/useAmiExtensions";

export const cellSx = {py: 1, px: 1.5, fontSize: 13, color: "#23264D", borderBottom: "1px solid #F2F2F7", whiteSpace: "nowrap"};
const iconButtonSx = {borderRadius: "50% !important", color: "#8A8AA0", "&:hover": {bgcolor: "#F4F4FA", color: "#4A4A63"}};

// Stops the row click (open campaign) from firing
const stop = (handler) => (e) => {
  e.stopPropagation();
  handler();
};

export const CampaignRowNew = ({campaign, extension, language, onOpen, onEdit, onDelete}) => {
  return (
    <TableRow hover sx={{cursor: "pointer", "&:hover": {bgcolor: "#FAFAFD"}}} onClick={() => onOpen(campaign)}>
      <TableCell sx={cellSx}>
        <Typography sx={{fontWeight: 700, fontSize: 13, color: "#23264D"}}>
          {campaign.name}
          {language && <Typography component="span" sx={{fontSize: 11, fontWeight: 700, color: "#8A8AA0", ml: 1}}>{language}</Typography>}
        </Typography>
        {campaign.description &&
          <Typography noWrap sx={{fontSize: 11, color: "#8A8AA0", maxWidth: 240}}>
            {campaign.description}
          </Typography>
        }
      </TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>{campaign.fromNumber || "-"}</TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>{extensionLabel(extension) || (campaign.extensionId ? "Unknown" : "-")}</TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>
        {moment(campaign.startDate).format("DD MMM YYYY")} – {moment(campaign.endDate).format("DD MMM YYYY")}
      </TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>{campaign.startTime} – {campaign.endTime}</TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>{campaign.maxAttempts}</TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>{campaign.totalPhoneNumbers ?? 0}</TableCell>
      <TableCell sx={{...cellSx, minWidth: 200}}>
        <CampaignStatusChipsNew statusCounts={campaign.statusCounts} statuses={["ANSWERED", "FAILED"]}/>
      </TableCell>
      <TableCell sx={{...cellSx, color: "#6B6B80"}}>
        {campaign.dateCreated ? moment(campaign.dateCreated).format("DD MMM YYYY HH:mm") : "-"}
      </TableCell>
      <TableCell padding="checkbox" sx={cellSx}>
        <Stack direction="row">
          <Tooltip title="Edit">
            <IconButton size="small" aria-label={`Edit ${campaign.name}`} onClick={stop(() => onEdit(campaign))} sx={iconButtonSx}>
              <HugeiconsIcon icon={PencilEdit01Icon} size={15}/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton size="small" aria-label={`Delete ${campaign.name}`} onClick={stop(() => onDelete(campaign))} sx={{...iconButtonSx, "&:hover": {bgcolor: "rgba(220, 38, 38, 0.08)", color: "#DC2626"}}}>
              <HugeiconsIcon icon={Delete02Icon} size={15}/>
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </TableRow>
  )
}
